export interface Page<T> {
  items: T[];
  total: number;
}

const DEFAULT_MAX_ITEMS = 2000;

// Fetches successive pages (pageIndex starts at 0) until the reported total is
// reached, a page comes back empty, or maxItems is collected. Sequential; any
// page rejection rejects the whole call.
export async function collectAllPages<T>(
  fetchPage: (pageIndex: number) => Promise<Page<T>>,
  opts?: { maxItems?: number },
): Promise<T[]> {
  const maxItems = opts?.maxItems ?? DEFAULT_MAX_ITEMS;
  const out: T[] = [];
  for (let i = 0; ; i++) {
    const page = await fetchPage(i);
    if (page.items.length === 0) break;
    out.push(...page.items);
    if (out.length >= maxItems) return out.slice(0, maxItems);
    if (out.length >= page.total) break;
  }
  return out;
}
